var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9643 0H28.1716L25.8859 2.28571H17.1071V11.0645L14.8214 13.3502V2.28571H3.39286C2.76429 2.28571 2.25 1.77143 2.25 1.14286C2.25 0.514286 2.76429 0 3.39286 0H15.9643ZM14.8214 21.8354L17.1071 19.5497V30.8571C17.1071 31.4857 16.5929 32 15.9643 32C15.3357 32 14.8214 31.4857 14.8214 30.8571V21.8354ZM31.4142 2.41421C31.8047 2.02369 31.8047 1.39053 31.4142 1C31.0237 0.609476 30.3905 0.609476 30 1L0.999986 30C0.609462 30.3905 0.609462 31.0237 0.999986 31.4142C1.39051 31.8047 2.02368 31.8047 2.4142 31.4142L31.4142 2.41421Z",
    fill: "#EC6523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakCluster);
export default __webpack_public_path__ + "static/media/break_cluster.58da47b367aab317aa9b75475c6f8cb6.svg";
export { ForwardRef as ReactComponent };